/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgIsolatedAlt = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M10.826 4.087A8 8 0 0 1 12 4h1V2h-1c-.493 0-.984.037-1.468.108zM18 10a4 4 0 1 0 0-8 4 4 0 0 0 0 8zm0-2a2 2 0 1 1 0-4 2 2 0 0 1 0 4zM6.628 6.072A7.999 7.999 0 0 1 8.579 4.77l-.854-1.81a10.003 10.003 0 0 0-2.44 1.63zM4.24 10.057a8.01 8.01 0 0 1 .898-2.17L3.423 6.859A9.999 9.999 0 0 0 2.3 9.57zm17.652 3.411c.071-.484.108-.975.108-1.468v-1h-2v1a8 8 0 0 1-.087 1.174zM4.468 14.695a8.005 8.005 0 0 1-.458-2.302l-1.998.097a10.011 10.011 0 0 0 .573 2.88zm14.942 4.021a10.023 10.023 0 0 0 1.63-2.44l-1.809-.855a8 8 0 0 1-1.303 1.951zm-12.176-.29a8 8 0 0 1-1.66-1.66l-1.606 1.191a10 10 0 0 0 2.075 2.075zM14.43 21.7a9.995 9.995 0 0 0 2.71-1.123l-1.027-1.715a8.002 8.002 0 0 1-2.17.899zm-2.823-1.71a8.003 8.003 0 0 1-2.302-.458l-.674 1.883a9.998 9.998 0 0 0 2.879.573z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgIsolatedAlt as IsolatedAlt };
